import React from 'react';
import { makeStyles, createStyles, Typography, Theme } from '@material-ui/core';
import { FaFacebookF } from 'react-icons/fa';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '455px',
      display: 'flex',
      justifyContent: 'center',
      [theme.breakpoints.down('lg')]: {
        minHeight: '390px',
      },
      backgroundColor: '#333',
      '& > *': {
        color: '#fff',
      },
    },
    content: {
      display: 'flex',
      justifyContent: 'center',
      maxWidth: '1170px',

      alignItems: 'center',
      padding: '2rem',
      '& > div': {
        marginRight: '1.25rem',
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        padding: '1rem',
        textAlign: 'center',
        '& > div': {
          marginBottom: '1.25rem',
        },
      },
    },
    fullWidth: {
      width: '100%',
    },
    logoText: {
      marginLeft: '0.5rem',
    },
    ico: {
      marginRight: theme.spacing(2),
    },
  }),
);

const Footer: React.FC = () => {
  const classes = useStyles();
  return (
    <footer className={classes.root}>
      <div className={classes.content}>
        <div className={classes.fullWidth}>
          <div>
            <img src={require('../../assets/logo.png')} alt="logo" />
          </div>
          <Typography className={classes.logoText} component="p" variant="h6">
            <a href='https://www.google.com/maps/place/3536+52nd+St+%232,+Kenosha,+WI+53144%D8%8C+%D8%A7%D9%84%D9%88%D9%84%D8%A7%D9%8A%D8%A7%D8%AA+%D8%A7%D9%84%D9%85%D8%AA%D8%AD%D8%AF%D8%A9%E2%80%AD/@42.5883475,-87.8491192,17z/data=!3m1!4b1!4m5!3m4!1s0x88055e21bee9ff9b:0x90541229f2c916b4!8m2!3d42.5883436!4d-87.8516941?entry=ttu&g_ep=EgoyMDI2MDMxOC4xIKXMDSoASAFQAw%3D%3D' target="_blanck" style={{ color: "white", textDecoration: "underline" }}> 
          3536 52nd St, Suite 2,
              <br />  
              Kenosha, WI 53144
              </a>
            <br/>
            <a href="tel:2629250535" style={{color:"white" , textDecoration:'none'}}>
        📞262-925-0535
    </a>
            <br /> 
          </Typography>
        </div>
        <div>
          <Typography component="p" variant="h6">
            No one should have to wait out an illness or injury because they
            can’t afford the right care. We keep our medical care affordable so
            people can take care of minor issues before they become big
            problems.
          </Typography>
        </div>
        <div>
          <a
            href="https://www.facebook.com/kenoshaurgicare"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebookF className={classes.ico} color="#ADADAD" />
          </a>
          <Typography component="p" variant="h6">
            We Proudly Offer Urgent Care Services in the Following Areas:
            Kenosha, Bristol, Paddock Lake, Pleasant Prairie, Burlington WI,
            Racine, Sturtevent, Waukegan IL, Zion IL, Lake Geneva WI, Gurnee IL
            Silver Lake, Twin Lakes, Fossland IL, Russell IL, Rosecrans IL, Dunn
            Corners IL & More...
          </Typography>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
